<template>
	<el-container direction="horizontal">
		<Aside></Aside>
			<el-container direction="vertical">
				<Header ></Header>
				<router-view />
				<!-- style="height: calc(100vh - 70px);" -->
			</el-container>
	</el-container>

</template>

<script>
	import {
		mapActions
	} from "vuex";
	import Aside from '../components/Aside'
	import Header from '../components/Header'
	// import {
	// 	checkLoginStatus
	// } from "../api/index.js"
	export default {
		data() {
			return {
			
			}
		},
		
		created() {
			// checkLoginStatus().then(res=>{
			// 	// console.log(res)
			// 	if(res.data.code==422){
			// 		if(this.$route.path!="/login"){
			// 			this.$message('请先登录');
			// 			this.$router.replace("/login");
			// 		}
			// 	}
			// })
			if(localStorage.getItem("user")){
				this.getAppInfoFromServer().then(res=>{
					if(res=="N"){
						this.$router.replace("/illustrate")
					}
				}).catch(err=>{
					console.log(err)
					this.$message.error('系统错误，请联系管理员')
				})
			}else{
				this.$router.replace("/login")
			}
			
		},
		components: {
			Aside,
			Header
		},
		methods: {
			...mapActions([
				"getAppInfoFromServer"
			]),
		}
	}
</script>

<style>

</style>
